<template>
  <div
    class="modal fade"
    tabIndex="-1"
    data-bs-backdrop="static"
    ref="modal"
  >
    <div
      class="modal-dialog modal-dialog-scrollable"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t("settings.user") }}</h5>
          <button
            type="button"
            class="btn btn-close"
            @click="hide"
            aria-label="Close"
          />
        </div>

        <div class="modal-body">
          <ul class="list-group">
            <li
              class="list-group-item text-left d-flex justify-content-between"
              v-for="(user, index) in users"
              :key="'user-' + index"
            >
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  :id="user.uid"
                  :ref="user.uid"
                  :checked="isUserAssigned(user.uid)"
                  @change="$emit('toggle-user', user.uid)"
                  :disabled="isUserDisabled(user)"
                />
                <label
                  class="form-check-label"
                  :for="user.uid"
                >
                  {{ user.displayName }}
                </label>
              </div>

              <button
                class="btn btn-link btn-sm"
                style="padding: 0 !important"
                type="button"
                @click="$emit('show-claims', user)"
                v-if="shouldShowClaimsButton(user.uid)"
              >
                <font-awesome-icon
                  :icon="['far', 'ellipsis-h']"
                  color="grey"
                />
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Modal} from "@comlinedev/bootstrap5";

  export default {
    name: "ToolUsersModal",
    props: {
      users: {
        type: Array,
        default: () => [],
      },
      assignedUsers: {
        type: Array,
        default: () => [],
      },
      claims: {
        type: Array,
        default: () => [],
      },
      currentUserState: {
        type: String,
        default: "",
      },
    },
    emits: ["toggle-user", "show-claims"],
    data() {
      return {
        modalInstance: null,
      };
    },
    methods: {
      show() {
        this.modalInstance?.show();
      },
      hide() {
        this.modalInstance?.hide();
      },
      isUserAssigned(uid) {
        return this.assignedUsers.includes(uid);
      },
      isUserDisabled(user) {
        return (
          user?.customClaims?.state === "superadmin" &&
          this.currentUserState === "admin"
        );
      },
      shouldShowClaimsButton(uid) {
        return (
          this.claims.length > 1 &&
          this.isUserAssigned(uid)
        );
      },
    },
    mounted() {
      this.modalInstance = new Modal(this.$refs.modal);
    },
  };
</script>
